import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import CryptoGamingHero from "./CryptoGamingHero";
import CryptoIndustry from "./CryptoIndustry";
import Empowering from "./Empowering";
import CorporatesSer from "./CorporatesSer";
import NFTIntegration from "./NFTIntegration";
import TakeYourGame from "./TakeYourGame";
import BlockchainExpertise from "../../AMM DEX/BlockchainExpertise";
import WhyChooseXeer from "../../DeFi/DeFiStaking/WhyChooseXeer";

function CryptoGaming() {
  return (
    <div>
      <Header />
      <CryptoGamingHero />
      <CryptoIndustry />
      <Empowering />
      <CorporatesSer />
      <NFTIntegration />
      <TakeYourGame />
      {/* <BlockchainExpertise /> */}
      <WhyChooseXeer />
      <Footer />
    </div>
  );
}

export default CryptoGaming;
